import { CursorQuery, Paginated } from '../../common/pagination.js';
import { CreateFundraiserInput, DonateInput, DonationResult, DonorRow, FundraiserView, } from '../../civic.js';
export const fundraiserRoutes = {
    create: {
        method: 'POST',
        path: '/fundraisers',
        body: CreateFundraiserInput,
        response: FundraiserView,
    },
    get: { method: 'GET', path: '/fundraisers/:fundraiserId', response: FundraiserView },
    donate: {
        method: 'POST',
        path: '/fundraisers/:fundraiserId/donations',
        body: DonateInput,
        response: DonationResult,
    },
    /** My Donors — the drawer entry (FR-FUND-08). */
    myDonors: {
        method: 'GET',
        path: '/me/donors',
        query: CursorQuery,
        response: Paginated(DonorRow),
    },
};
//# sourceMappingURL=routes.js.map